import {Component} from 'react'
import {createLocation} from 'history'
import { isEmpty } from '../../../../../shared/services/lodashInJS.js'
import { toPositiveIntString } from '../../../../../shared/services/searchService.js'
import {connect} from 'react-redux'
import {isString} from "validate.js"

import {generate} from '../../../../routes.js'
import mustHaveAcceptedCGU from '../../../../components/Must/MustHaveAcceptedCGU.jsx'
import conf from '../../../../conf.js'
import SearchContainer from '../../../Search/SearchContainer.jsx'
import {searchFreelances} from '../../../Search/actions.js'
import {isAdmin} from '../../../../../shared/services/userService.js'

import '../../../Search/Search.scss'

const handleArrayTypeData = (data) => {
  if(Array.isArray(data)) {
    return data
  }
  if(isString(data) && data.indexOf(',')){
    return data.split(',')
  }
  return [data]
}

class FreelanceSearchContainer extends Component {
  static searchRouteName = 'search.results'

  search = async (data) => {
    if (data.price_min === 0 && data.price_max === 0) {
      return
    }
    this.props.history.push(createLocation(
      generate({
        name: FreelanceSearchContainer.searchRouteName,
        search: this.flattenSearchObject({
          ...data,
          page: 1
        })
      })
    ))
  }

  flattenSearchObject = (data) => {
    const {page, ...output} = data

    if (page > 1) {
      output.page = page
    }

    if (isEmpty(output.city) && isEmpty(output.latitude) && isEmpty(output.longitude)) {
      delete output.city
      delete output.latitude
      delete output.longitude
    }

    if (isEmpty(output.sort_tjm)) {
      delete output.sort_tjm
    }

    if (isEmpty(output.sort_availability)) {
      delete output.sort_availability
    }

    delete output.target

    return output
  }

  expandSearchObject = (search, currentUniverseId) => {
    const {keywords, humanSkills, languages, limit, page, universe, nbYearOfExperience, itSkills,  ...output} = search

    if (!isEmpty(keywords)) {
      output.keywords = handleArrayTypeData(keywords)
    }
    if (!isEmpty(languages)) {
      output.languages = handleArrayTypeData(languages)
    }
    if (!isEmpty(humanSkills)) {
      output.humanSkills = handleArrayTypeData(humanSkills)
    }
    if (!isEmpty(nbYearOfExperience)) {
      output.nbYearOfExperience = handleArrayTypeData(nbYearOfExperience)
    }
    if (!isEmpty(itSkills)) {
      output.itSkills = handleArrayTypeData(itSkills)
    }

    output.universe = (universe || currentUniverseId).toString()
    output.page = toPositiveIntString(page, 1)
    output.limit = toPositiveIntString(limit, conf.search.limits.cards)
    output.target = conf.search.targets.freelances

    return output
  }

  render() {
    return (
      <SearchContainer
        expandSearchObject={this.expandSearchObject}
        flattenSearchObject={this.flattenSearchObject}
        search={this.search}
        routes={this.props.route.routes}
        dispatchSearch={this.props.searchFreelances}
        searchRouteName={FreelanceSearchContainer.searchRouteName}
        searchTarget={conf.search.targets.freelances}
      />
    )
  }
}

export default mustHaveAcceptedCGU(
  connect(
    (state) => ({
      isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse),
      search: state.search.search
    }),
    (dispatch) => ({
      searchFreelances: (model) => dispatch(searchFreelances(model))
    })
  )(FreelanceSearchContainer)
)
